// extracted by mini-css-extract-plugin
module.exports = {"Document":"Document_Document__386Zt","Error":"Document_Error__2BZKP"};